import { Styles } from "../../legacyComponents/config"

export default {
	label: {
		fontSize: "12px"
	},

	autocomplete(disabled) {
		return {
			width: "100%",
			height: "50px",
			border: "1px solid #acbee8",
			borderRadius: "5px",
			background: disabled ? Styles.Color.colorDisabled : "inherit",

			"@media (max-width: 767px)": {
				height: "45px"
			},

			"& .MuiOutlinedInput-root": {
				padding: "0px !important"
			},

			"& .MuiOutlinedInput-root .MuiAutocomplete-input": {
				padding: "16.5px 14px !important"
			},

			"& input": {
				fontSize: "14px",
				color: "#465578"
			},

			"& fieldset": {
				border: "none"
			}
		}
	},

	autoOptions: {
		padding: "0px !important",
		fontSize: "14px",

		"& li": {
			margin: "0px !important",
			padding: "6px 17px !important",
			color: "black"
		}
	},

	checkboxPairContainer: {
		width: "150px",
		flexShrink: 0,
		justifyContent: "center",
		alignContent: "center"
	},
	
	checkboxPairContainerFull: {
		width: "150px",
		flexShrink: 0,
		justifyContent: "center",
		alignContent: "center"
	},
	
	checkboxLabel: {
		cursor: "pointer"
	},

	info: {
		fontSize: "12px"
	},

	error: {
		fontSize: "12px",
		color: Styles.Color.danger
	},
	select(isInactive) {
		return {
			width: "100%",
			height: "50px",
			border: "1px solid #acbee8",
			borderRadius: "5px",
			padding: "0 12px",
			fontSize: "14px",
			color: isInactive ? "#acbee8" : "#465578", // 👈 lighter text
			// background: isInactive ? Styles.Color.colorDisabled : "#fff", // 👈 gray bg
			cursor: "pointer",
			appearance: "none",
			outline: "none",
			opacity: isInactive ? 0.7 : 1,

			"&:focus": {
				borderColor: "#6c63ff",
			},

			"& option[disabled]": {
				color: "#9ca3af",
				opacity: 0.7,
			},

			// "@media (max-width: 767px)": {
			// height: "45px",
			// fontSize: "13px"
			// }
		}
	}

}
